export default __webpack_public_path__ + "static/media/ramit.bf9e5a55.jpg";